<template>
  <div class="lh-homes imgs" style="background-image:url(img/bg1.jpg)">
    <div class="lh-logo1"><img src="img/logo-a.png" /><span>安全生产：{{logoText}}</span></div>
    <div class="lh-case imgs" style="background-image:url(img/a5.png)">
    	<h3 class="num imgs" style="background-image:url(img/b1.png)">案例:{{datasIdx+1}}</h3>
    	<div class="ccont">{{datas[datasIdx].ccont}}</div>
    	<div class="btn clearfix">
    		<a href="javascript:;" data-result="1" @click="answer($event)"><img src="img/b3.png" /></a>
    		<a href="javascript:;" data-result="2" @click="answer($event)"><img src="img/b2.png" /></a>
    	</div>
    	<a href="javascript:;" class="next" @click="next($event)"><img src="img/b4.png" /></a>
    	<div class="result">
    		<img :src="resultImg" />
    	</div>
    </div>
    <Footer :footerData="footerData"></Footer>
  </div>
</template>

<script>
import Footer from '@/components/Footer'
export default{
	data(){
		return {
			footerData:{audioData:{total:'00:00',current:'00:00',percentage:0,icon:'icon-bofang',text:''},page:2,type:'culture'},
			logoText:'工伤——工伤认定',
			datasIdx:0,
			resultImg:'img/no.png',
			datas:[
				{ccont:'某铁路局客运某段列车员武某随列车到达某站，客车准备完毕后，到库外吃早餐，返回车库途中，遭遇一男性歹徒持刀抢劫，造成右手背、右拇指皮肤裂伤约8cm，右食指肌腱损伤。',result:'1',hover:'on',end:''},
				{ccont:'某制品厂因客户急需产品加班。工人彭某负责打磨工作，由于任务紧，劳动强度大，在超负荷的工作过程中，至使当时腰部不适，第二天腰部疼痛严重，不能活动。经治疗后，仍反复疼痛，不能受力，不能参加正常生产工作。于是到医院就诊，门诊诊断为：腰病二年余，近期加重，CT提示L3-4、4-5、L5-S1椎间盘膨出，L5-S1椎间盘突出，及小关节骨质增生，硬膜囊受压。',result:'1',hover:'',end:''},
				{ccont:'徐某是某管业公司职工，其与公司一直没有签订书面劳动合同，某管业公司也没有依法给徐某缴纳工伤保险，但公司按时将每月2700元左右的工资发到他手上。 2013年8月 25 日，徐某在某管业公司铸造车间工作时，被铁水溅入双眼受伤，同日入住中国人民解放军第八十九医院治疗，诊断为角、结膜热烧伤，共住院 52 天；后又于2013年10月16日入住潍坊医学院附属医院治疗，诊断为角膜烧伤、睑球粘连、角膜变性，共住院 19 天；徐某又于 2014年4月30 日入住潍坊眼科医院治疗，诊断为睑球粘连(左)、陈旧性热烧伤(左)，共住院78天。',result:2,hover:'',end:''},
				{ccont:'潘某系南京某机械设备制造有限公司职工。2007年9月25日上午7时45分，潘某到单位上班，在快进公司大门口时被本单位的一辆货车撞伤，造成右腿胫腓骨骨折，住院治疗18天，经鉴定伤残等级为十级，后被认定为工伤。其所在单位为潘某办理了工伤保险理赔。同年11月7日，潘某将其所在单位南京某机械设备制造有限公司和南京某财产保险公司告上法庭，要求赔偿各项损失计73894元。',result:'2',hover:'',end:''},
				{ccont:'上年年10月12日，赵雨向北京市朝阳区劳动和社会保障局递交工伤认定申请表，称自己系微软(中国)有限公司(以下简称微软公司)职工，其在2004年7月5日按照微软公司的要求入住九华山庄参加会议，当晚在客房内洗澡时因浴室防滑垫失效滑倒，次日被送往北京大学第三医院诊冶。诊断结论为：右膝内侧半月板损伤，右侧胫骨平台骨折，右膝内侧副韧带撕脱，右股骨内踝骨软骨损伤。',result:'1',hover:'',end:''},
			]
		}
	},
	created(e){
		var that=this;
	    that.openAnimate();
	},
	mounted(e){
      var that=this;
    },
	components:{
		Footer
	},
	methods:{
		openAnimate(e){
			setTimeout(function(){
				$('.lh-homes').addClass('Start');
			},0);
		},
		answer(e){
			var that=this,tag = $(e.currentTarget),result=$(e.currentTarget).data('result');
			if(result==that.datas[that.datasIdx].result){
				that.resultImg='img/ok.png';
			}else{
				that.resultImg='img/no.png';
			}
			$('.lh-homes').addClass('Answer');
		},
		next(e){
			var that=this,tag = $(e.currentTarget);
			$('.lh-homes').removeClass('Start Answer');
			setTimeout(function(){
				that.datasIdx+=1;
				if(that.datasIdx>=5){
					that.$router.replace({ path: 'progress'});
				}
				that.resultImg='';
			},250);
			setTimeout(function(){
				$('.lh-homes').addClass('Start');
			},450);
		},
		gotoNext(e){
			var that=this,tag = $(e.currentTarget),path=$(e.currentTarget).data('path');
			that.$router.replace({ path: path});
		},
	}
}
</script>
